import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const AutoscalingIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props} width="16" height="16" viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="8" fill="#FAD2FB" />
      <path
        d="M10.6239 11.519L9.89146 9.43951H7.02829L6.29585 11.519H5L7.78634 4H9.14878L11.93 11.519H10.6239ZM9.5739 8.38439L8.86195 6.33561C8.83463 6.24683 8.79537 6.1222 8.74415 5.96171C8.69293 5.79781 8.64171 5.6322 8.59049 5.46488C8.53927 5.29415 8.49659 5.15073 8.46244 5.03463C8.42829 5.17463 8.38561 5.33171 8.33439 5.50585C8.28659 5.67659 8.23878 5.83707 8.19098 5.98732C8.14659 6.13756 8.11244 6.25366 8.08854 6.33561L7.37146 8.38439H9.5739Z"
        fill="black"
      />
    </Icon>
  );
};
